module.exports = __webpack_public_path__ + "img/taskbg.9fd6fbea.png";